<template>
  <div>
    <div>{{ count }}{{ extraDisplay }}</div>
  </div>
</template>

<script>
export default {
  props: {
    count: [String, Number],
    supcount: Object,
  },
  components: {},
  computed: {
    extraDisplay() {
      const tour_guides = this.supcount.tour_guides || 0;
      const transport = this.supcount.transport || 0;
      const extras = tour_guides + transport;
      return extras ? `+${extras}` : "";
    },
  },
  methods: {},
};
</script>
